// Delegate to the primary form so app properties, quantities, errors and events
// follow the same path on desktop and mobile.
if (!customElements.get('sticky-product-controls')) {
  customElements.define('sticky-product-controls', class extends HTMLElement {
    connectedCallback() { queueMicrotask(() => this.initialize()); }

    initialize() {
      if (!this.isConnected || this.controller) return;
      this.section = this.closest('[id^="MainProduct-"]');
      this.form = this.section?.querySelector('form[data-type="add-to-cart-form"]');
      this.primary = this.form?.querySelector('[name="add"]');
      this.link = this.form?.querySelector('.product-form__buttons a');
      this.quantity = this.section?.querySelector('input[name="quantity"]');
      this.stickyQuantity = this.querySelector('.v2-sticky-quantity__input');
      this.buttons = [...this.querySelectorAll('[data-sticky-add]')];
      if (!this.form || (!this.primary && !this.link)) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.buttons.forEach(button => button.addEventListener('click', event => {
        event.preventDefault();
        if (button.disabled || this.primary?.disabled || this.primary?.getAttribute('aria-disabled') === 'true') return;
        if (this.link) this.link.click();
        else this.form.requestSubmit(this.primary);
      }, options));
      this.querySelectorAll('[data-sticky-quantity-step]').forEach(button => button.addEventListener('click', () => {
        if (!this.quantity) return;
        this.quantity.stepUp(Number(button.dataset.stickyQuantityStep));
        this.quantity.dispatchEvent(new Event('change', { bubbles: true }));
        this.sync();
      }, options));
      this.stickyQuantity?.addEventListener('change', () => {
        if (!this.quantity) return;
        if (!this.stickyQuantity.checkValidity()) { this.stickyQuantity.reportValidity(); return; }
        this.quantity.value = this.stickyQuantity.value;
        this.quantity.dispatchEvent(new Event('change', { bubbles: true }));
        this.sync();
      }, options);
      this.quantity?.addEventListener('input', () => this.sync(), options);
      this.quantity?.addEventListener('change', () => this.sync(), options);
      this.observer = new MutationObserver(() => this.sync());
      if (this.primary) this.observer.observe(this.primary, { attributes: true, childList: true, subtree: true });
      if (this.quantity) this.observer.observe(this.quantity, { attributes: true });
      const price = this.section.querySelector('[id^="price-"]');
      if (price) this.observer.observe(price, { attributes: true, childList: true, subtree: true });
      if (typeof subscribe === 'function') this.unsubscribe = subscribe(PUB_SUB_EVENTS.quantityUpdate, () => this.sync());
      this.bar = this.querySelector('.v2-sticky-atc-bar');
      const onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.updateVisibility(); });
      };
      window.addEventListener('scroll', onScroll, { ...options, passive: true });
      window.addEventListener('resize', onScroll, options);
      this.sync();
      this.updateVisibility();
    }

    sync() {
      const busy = this.primary?.getAttribute('aria-disabled') === 'true';
      const disabled = !this.link && (!this.primary || this.primary.disabled || busy);
      const text = (this.primary || this.link)?.querySelector('span')?.textContent.trim();
      this.buttons.forEach(button => {
        button.disabled = Boolean(disabled);
        button.setAttribute('aria-busy', String(Boolean(busy)));
        const label = button.querySelector('[data-sticky-button-text]');
        if (text && label) label.textContent = text;
        button.querySelector('.loading-overlay__spinner')?.classList.toggle('hidden', !busy);
      });
      if (this.quantity && this.stickyQuantity) {
        this.stickyQuantity.value = this.quantity.value;
        for (const name of ['min', 'max', 'step']) {
          const value = this.quantity.getAttribute(name);
          if (value === null) this.stickyQuantity.removeAttribute(name);
          else if (this.stickyQuantity.getAttribute(name) !== value) this.stickyQuantity.setAttribute(name, value);
        }
      }
      const source = this.section.querySelector('[id^="price-"]');
      const target = this.querySelector('.v2-sticky-atc-bar__price');
      if (source && target && target.innerHTML !== source.innerHTML) target.innerHTML = source.innerHTML;
    }

    updateVisibility() {
      this.bar?.classList.toggle('v2-sticky-atc-bar--visible', this.section.getBoundingClientRect().bottom < window.innerHeight / 2);
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.unsubscribe?.();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = null;
      this.controller = null;
    }
  });
}
